import { useEffect, useRef } from 'react';
import { createVisiblePoller } from '../utils/visiblePolling';

export function useVisiblePolling(refresh, enabled = true, interval = 30000) {
  const callback = useRef(refresh);
  callback.current = refresh;
  useEffect(() => {
    if (!enabled) return undefined;
    return createVisiblePoller(() => callback.current(), { interval });
  }, [enabled, interval]);
}
